export const mainRoutes = {
  root: '/',
};
